import {
  createContext,
  useContext,
  useEffect,
  useState,
  type Dispatch,
  type ReactNode,
  type SetStateAction,
} from 'react';
import { useLocation } from 'react-router-dom';

import { apiClient } from '@/services';

type DueTrainingCountContextValue = {
  dueCount: number | null;
  setDueCount: Dispatch<SetStateAction<number | null>>;
};

const DueTrainingCountContext = createContext<DueTrainingCountContextValue | null>(null);

export function DueTrainingCountProvider({ children }: { children: ReactNode }) {
  const { pathname } = useLocation();
  const [dueCount, setDueCount] = useState<number | null>(null);

  useEffect(() => {
    let mounted = true;

    apiClient.getTrainingCards(1)
      .then((response) => {
        if (!mounted) return;
        setDueCount(response.dueCount ?? 0);
      })
      .catch(() => {
        // Non-critical badge; keep the previous count on failure.
      });

    return () => {
      mounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return (
    <DueTrainingCountContext.Provider value={{ dueCount, setDueCount }}>
      {children}
    </DueTrainingCountContext.Provider>
  );
}

export function useDueTrainingCount(): DueTrainingCountContextValue {
  const context = useContext(DueTrainingCountContext);
  if (!context) {
    throw new Error('useDueTrainingCount must be used within a DueTrainingCountProvider');
  }
  return context;
}
